import { Vue, Component } from 'vue-property-decorator';
import { NotificationPrefType } from '@/features/settings/types';
import { updateNotificationPref } from '@/features/settings/services/notifications.services';
import ChangesSaved from '@/features/settings/components/ChangesSaved.vue';

@Component({
  components: {
    ChangesSaved,
  },
})
export class NotificationMixin extends Vue {
  private showAlert = {
    success: false,
    show: false,
  };

  get isNotificationPrefs(): boolean {
    return this.$store.getters.getIsNotificationPrefs;
  }

  get notificationPrefs(): NotificationPrefType[] {
    return this.$store.getters.getNotificationPrefs;
  }

  public searchNotificationPref(name: string): boolean {
    const notification = this.notificationPrefs.find((pref) => pref.name === name);
    if (!notification) return true;
    return notification.show;
  }

  private async updatePref(name: string, value: boolean) {
    this.$store.commit('patchNotificationPref', {
      name,
      value,
    });

    const response = await updateNotificationPref(name, value);

    this.showAlert = {
      show: true,
      success: !!response,
    };
  }
}
